import { createContext, useContext, useReducer } from 'react';
import { ACTION_TYPES, ConsultaRemessaReducer, ConsultaRemessaState } from './consulta-remessa-reducer';
import { PaginationResponse } from '../../../../model/base/response/pagination-response';
import { IPublicationShipmentResponse } from '../../../../model/publication-shipment/response/publication-shipment-response';
import { IListUsersSendpPublicationShipmentRequest } from '../../../../model/publication-shipment/request/list-users-publication-shipment-request';
import { IPublicationShipmentStatusResponse } from '../../../../model/publication-shipment/response/publication-shipment-status-response';

const ConsultaRemessaContext = createContext<ConsultaRemessaState | undefined>(undefined);
const ConsultaRemessaContextDispatchContext = createContext({} as any);

const ConsultaRemessaProvider = ({ children }: { children: React.ReactNode }) => {
    const [state, dispatch] = useReducer(ConsultaRemessaReducer, { listPublicationShipmentResponse: { items: [] as IPublicationShipmentResponse[], page: 0, pageSize: 0, pageCount: 0 } as PaginationResponse<IPublicationShipmentResponse>, listPublicationShipmentPagedRequest:{page:0, pageSize:50}, listUsersSend:[] as IListUsersSendpPublicationShipmentRequest[], listSatusPublicatioShipment:[] as IPublicationShipmentStatusResponse[]} as ConsultaRemessaState);

    return (
        <ConsultaRemessaContext.Provider value={state}>
            <ConsultaRemessaContextDispatchContext.Provider value={dispatch}>
                {children}
            </ConsultaRemessaContextDispatchContext.Provider>
        </ConsultaRemessaContext.Provider>
    );
}

const useConsultaRemessaState = () => {
    const context = useContext(ConsultaRemessaContext);
    if (context === undefined) {
        throw new Error('useHomeState must be used within a HomeProvider');
    }
    return context;
}

const useConsultaRemessaDispatch = () => {
    const context = useContext(ConsultaRemessaContextDispatchContext);
    if (context === undefined) {
        throw new Error('useHomeDispatch must be used within a HomeProvider');
    }
    return context;
}

export { ConsultaRemessaProvider, useConsultaRemessaDispatch, useConsultaRemessaState, ACTION_TYPES };
